import React, { useState } from "react";
import { supabase } from "../pages/supabaseClient";

function validatePassword(password) {
  const rules = [
    { regex: /.{8,}/, message: "At least 8 characters" },
    { regex: /[A-Z]/, message: "At least one uppercase letter" },
    { regex: /[a-z]/, message: "At least one lowercase letter" },
    { regex: /[0-9]/, message: "At least one number" },
    { regex: /[^A-Za-z0-9]/, message: "At least one special character" }
  ];
  return rules.filter(rule => !rule.regex.test(password)).map(rule => rule.message);
}

export default function ResetPassword({ onComplete }) {
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    const failed = validatePassword(password);
    setErrors(failed);
    if (failed.length > 0) return;
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    if (error) {
      setMessage("Error: " + error.message);
    } else {
      setMessage("Password updated! You can now log in.");
      if (onComplete) onComplete();
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 400, margin: "60px auto", background: "#fff", padding: 32, borderRadius: 12, boxShadow: "0 2px 12px #0001" }}>
      <h2 style={{ marginBottom: 24 }}>Set Your Password</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="New password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          style={{
            width: "100%",
            marginBottom: 16,
            padding: "12px 10px",
            borderRadius: 6,
            border: "1px solid #cbd5e1",
           background: "#fff !important",
          color: "#222 !important",
            fontSize: 16
          }}
        />
        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "12px 0",
            background: "#2979ff",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            fontWeight: 600,
            fontSize: 16,
            cursor: "pointer",
            marginBottom: 16,
            boxShadow: "0 2px 6px #2979ff22"
          }}
        >
          {loading ? "Saving..." : "Set Password"}
        </button>
        {errors.length > 0 && (
          <ul style={{ color: "crimson", marginTop: 8 }}>
            {errors.map((err, i) => <li key={i}>{err}</li>)}
          </ul>
        )}
        {message && <div style={{ color: message.startsWith("Error") ? "crimson" : "green", marginTop: 12 }}>{message}</div>}
      </form>
      <div style={{ marginTop: 16, fontSize: 13, color: "#555" }}>
        Password must have:
        <ul>
          <li>At least 8 characters</li>
          <li>At least one uppercase letter</li>
          <li>At least one lowercase letter</li>
          <li>At least one number</li>
          <li>At least one special character</li>
        </ul>
      </div>
    </div>
  );
}